import moment from "moment-timezone";
import React, { ChangeEvent, Component } from "react";
import "./PackingListDetail.scss";
import { Link } from "react-router-dom";
import ControlTypeEnum from "../../../models/ControlTypeEnum";
import ICreateShipmentFromPackingListDTO from "../../../models/DTO/ICreateShipmentFromPackingListDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetLotsDTO from "../../../models/DTO/IGetLotsDTO";
import IGetPackingListDTO from "../../../models/DTO/IGetPackingListDTO";
import IOnGetLotsDTO from "../../../models/DTO/IOnGetLotsDTO";
import IOnGetPackingListDTO from "../../../models/DTO/IOnGetPackingListDTO";
import IOnProcessLotDTO from "../../../models/DTO/IOnProcessLotDTO";
import IOnUpdatePackingListDTO from "../../../models/DTO/IOnUpdatePackingListDTO";
import IOnUpdatePackingListLockDTO from "../../../models/DTO/IOnUpdatePackingListLockDTO";
import IUpdatePackingListDTO from "../../../models/DTO/IUpdatePackingListDTO";
import IUpdatePackingListLockDTO from "../../../models/DTO/IUpdatePackingListLockDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAddress from "../../../models/IAddress";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ILot from "../../../models/ILot";
import ILotUI from "../../../models/ILotUI";
import INewOrder_Item_Lot_Map from "../../../models/INewOrder_Item_Lot_Map";
import IOrder from "../../../models/IOrder";
import IOrder_ItemUI from "../../../models/IOrder_Item";
import IOwTableCols from "../../../models/IOwTableCols";
import IPacking_List from "../../../models/IPacking_List";
import IShipment_Group from "../../../models/IShipment_Group";
import IUpdatePackingListRow from "../../../models/IUpdatePackingListRow";
import IUpdatePackingListSourceRow from "../../../models/IUpdatePackingListSourceRow";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import IViewOptions from "../../../models/IViewOptions";
import UserTypesEnum from "../../../models/UserTypesEnum";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import CreateLotSidebar from "../../lots/CreateLotSidebar/CreateLotSidebar";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import _ from "lodash";
import { OwViewOptionsPanel } from "../../shared/OwViewOptionsPanel/OwViewOptionsPanel";
import Typeahead from "../../shared/Typeahead/Typeahead";
import ShipmentPackageSidebar from "../../shipments/ShipmentPackageSidebar/ShipmentPackageSidebar";
import { Socket } from "socket.io-client";
import { IOption } from "../../../models/IOption";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import { DocLogo } from "../../shared/DocLogo/DocLogo";
import { WhiteLabelLogo } from "../../shared/WhiteLabelLogo/WhiteLabelLogo";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import ISupplierSettings from "../../../models/ISupplierSettings";
import { OwBarcode } from "../../shared/OwBarcode/OwBarcode";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    supplierModel: ISupplierModel;
    history: any;
    match: any;
    location: any;
    toggleMenu: () => void;
};

type State = {
    crumbs: IBreadcrumbs[];
    packingListGuid: string;
    packingList: IPacking_List;
    catalogItems: ICatalog_Item[];
    hasOneOrder: boolean;
    orderItems: IOrder_ItemUI[];
    isSaveActive: boolean;
    isFinalizeActive: boolean;
    hasUnsavedChanges: boolean;
    showItemPhoto: boolean;
    showPhone: boolean;
    showEmail: boolean;
    showOrder: boolean;
    showPickQty: boolean;
    showOrderQty: boolean;
    showShipQty: boolean;
    hideSkuCol: boolean;
    showDropshipment: boolean;
    showUom: boolean;
    showUpc: boolean;
    showSku: boolean;
    showOrderDescription: boolean;
    columns: IOwTableCols[];
    detailViewCols: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
    qtyAssigned: {
        [key: string]: {
            qty_picked: number;
            value: number;
            sources: { [key: string]: { qty_picked: number; value: number; parent_catalog_item_id: number; order_id: number } };
        };
    };
    height: number;
    width: number;
    length: number;
    shipment_date: string;
    note: string;
    tracking: string;
    shipment_status_id: number;
    shipping_carrier_id: number;
    foundLots: { [key: string]: ILot[] };
    selectedLots: { [key: string]: ILot | null };
    clearTypeahead: boolean;
    pageSize: "STANDARD" | "MINIMAL";
    hideBusinessName: boolean;
    inlineLogoName: boolean;
    showBillToPhone: boolean;
    showShipToPhone: boolean;
    showOrderUser: boolean;
    showBillTo: boolean;
    totalOrders: number;
};

/**
 * @deprecated
 *
 * This is deprecated for PackingListDetailFn
 */
class PackingListDetail extends Component<Props, State> {
    packingListTemplates: IOption[] = [
        { value: "STANDARD", label: "8.5x11" },
        { value: "MINIMAL", label: "4x6" },
    ];

    supplierSettings: ISupplierSettings =
        typeof this.props.supplierModel.settings === "string"
            ? JSON.parse(this.props.supplierModel.settings)
            : this.props.supplierModel.settings;

    getSupplierSetting = (viewOption: string, defaultValue: boolean): boolean => {
        // @ts-expect-error
        if (this.supplierSettings.simple_packing_list && !_.isNil(this.supplierSettings.simple_packing_list[viewOption])) {
            // @ts-expect-error
            return this.supplierSettings.simple_packing_list[viewOption];
        } else {
            return defaultValue;
        }
    };

    constructor(props: any) {
        super(props);
        const columns: IOwTableCols[] = [
            {
                isActionsCol: true,
                title: "",
                valueProp: "",
                hasChevron: true,
                className: "w-3r d-print-none",
                showChevronFn: this.showChevronFn,
            },
            {
                title: "order",
                valueProp: "",
                renderFn: this.orderRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.showOrder;
                },
            },
            {
                title: "sku",
                valueProp: "Catalog_Item",
                valueSubProp: "sku",
                renderFnEmitsRow: true,
                renderFn: this.renderSkuFn,
                isChecked: () => {
                    return this.state.showSku;
                },
            },
            {
                title: "upc",
                valueProp: "Catalog_Item",
                valueSubProp: "upc",
                renderFnEmitsRow: true,
                renderFn: this.renderUpcFn,
                isChecked: () => {
                    return this.state.showUpc;
                },
            },
            {
                title: "uom",
                valueProp: "Catalog_Item",
                valueSubProp: "Unit_Of_Measurement",
                renderFnEmitsRow: true,
                renderFn: this.renderUomFn,
                isChecked: () => {
                    return this.state.showUom;
                },
            },
            {
                title: "description",
                valueProp: "Catalog_Item",
                valueSubProp: "description",
                className: "pre-wrap",
            },
            {
                title: "pick_qty",
                valueProp: "qty",
                className: "text-end d-print-none",
                renderFn: this.pickQtyRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.showPickQty;
                },
            },
            {
                title: "order_qty",
                valueProp: "qty",
                className: "text-end",
                renderFn: this.orderQtyRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.showOrderQty;
                },
            },
            // {
            //     title: "already_sent",
            //     valueProp: "qty_shipped",
            //     renderFn: this.qtyShippedRenderFn,
            //     className: "text-end",
            // },
            {
                title: "ship_qty",
                valueProp: "ship_qty",
                renderFn: this.shipQtyRenderFn,
                renderFnEmitsRow: true,
                className: "text-end",
                isChecked: () => {
                    return this.state.showShipQty;
                },
            },
        ];

        if (this.props.supplierModel.has_lots) {
            columns.push({
                title: "lots",
                valueProp: "",
                renderFn: this.hasLotsRenderFn,
                renderFnEmitsRow: true,
                className: "text-center d-print-none",
            });

            // columns.push({
            //     title: "lot",
            //     valueProp: "",
            //     renderFn: this.lotRenderFn,
            //     renderFnEmitsRow: true,
            //     className: "text-end w-12r",
            // });
            //
            // if (this.props.supplierModel.has_exp_date) {
            //     columns.push({
            //         title: "exp_date",
            //         valueProp: "",
            //         renderFn: this.expDateRenderFn,
            //         renderFnEmitsRow: true,
            //         className: "text-end w-8r",
            //     });
            // }
        }

        if (this.props.supplierModel.has_cartons) {
            columns.push({
                title: "cartons",
                valueProp: "",
                renderFn: this.cartonRenderFn,
                renderFnEmitsRow: true,
                className: "text-end w-8r",
            });
        }

        this.state = {
            crumbs: [
                { title: "Packing Lists", url: "/packing_lists" },
                { title: "Detail", url: "/packing_lists/:guid" },
            ],
            packingListGuid: this.props.match.params.packing_list_guid,
            packingList: {} as IPacking_List,
            isSaveActive: false,
            isFinalizeActive: false,
            hasUnsavedChanges: false,
            hasOneOrder: true,
            showItemPhoto: this.getSupplierSetting("show_item_photo", false),
            showPhone: this.getSupplierSetting("show_phone", false),
            showEmail: this.getSupplierSetting("show_email", true),
            showOrder: true,
            showOrderQty: this.getSupplierSetting("show_order_qty", true),
            showPickQty: this.getSupplierSetting("show_pick_qty", true),
            showShipQty: this.getSupplierSetting("show_ship_qty", true),
            showDropshipment: this.getSupplierSetting("show_dropshipment", false),
            showOrderDescription: this.getSupplierSetting("show_order_desc", false),
            showUom: this.getSupplierSetting("show_uom", true),
            showUpc: this.getSupplierSetting("show_upc", false),
            showSku: this.getSupplierSetting("show_sku", false),
            hideSkuCol: this.getSupplierSetting("hide_sku_col", false),
            columns,
            detailViewCols: [],
            isDataFetching: false,
            isInitialData: true,
            catalogItems: [],
            orderItems: [],
            qtyAssigned: {},
            shipment_date: "",
            note: "",
            tracking: "",
            height: 0,
            length: 0,
            width: 0,
            shipment_status_id: 1,
            shipping_carrier_id: 1,
            foundLots: {},
            selectedLots: {},
            clearTypeahead: false,
            pageSize: "STANDARD",
            hideBusinessName: this.getSupplierSetting("hide_business_name", false),
            inlineLogoName: this.getSupplierSetting("inline_logo_name", false),
            showBillToPhone: this.getSupplierSetting("show_bill_to_phone", false),
            showShipToPhone: this.getSupplierSetting("show_ship_to_phone", true),
            showOrderUser: this.getSupplierSetting("show_order_user", false),
            showBillTo: this.getSupplierSetting("show_bill_to", true),
            totalOrders: 0,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.OrderOnGetPackingList, this.onGetPackingList);
        this.props.socket.on(EndpointsEnum.OrderOnUpdatePackingList, this.onUpdatePackingList);
        this.props.socket.on(EndpointsEnum.OrderOnUpdatePackingListLock, this.onUpdatePackingListLock);
        this.props.socket.on(EndpointsEnum.CatalogItemOnGetLots, this.onGetLots);

        this.getPackingList();
        this.setupDetailViewCols();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.OrderOnGetPackingList, this.onGetPackingList);
        this.props.socket.removeListener(EndpointsEnum.OrderOnUpdatePackingList, this.onUpdatePackingList);
        this.props.socket.removeListener(EndpointsEnum.OrderOnUpdatePackingListLock, this.onUpdatePackingListLock);
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnGetLots, this.onGetLots);
    }

    setupDetailViewCols = () => {
        const detailViewCols = [
            {
                className: "w-2pt25r",
                isActionsCol: true,
                title: "",
                valueProp: "",
            },
            {
                className: "text-end w-8r",
                title: "",
                valueProp: "",
            },
            {
                className: "w-15r",
                title: "sku",
                valueProp: "sku",
            },
            {
                className: "w-15r",
                title: "manufacturer",
                valueProp: "manufacturer",
            },
            {
                title: "description",
                valueProp: "description",
            },
            {
                className: "w-10r text-center-print",
                title: "ship_qty",
                valueProp: "",
                renderFn: this.qtyPickedRenderFn,
                renderFnEmitsRow: true,
            },
        ];

        this.setState({
            detailViewCols,
        });
    };

    renderSkuFn = (row: IOrder_ItemUI) => {
        if (row.Catalog_Item?.sku) {
            return (
                <div className={"d-flex " + (this.state.showItemPhoto ? "" : "flex-column")}>
                    <div>
                        {this.state.showItemPhoto ? (
                            <div>
                                <OwS3ImageViewer catalogItem={row.Catalog_Item} />
                            </div>
                        ) : null}
                        <div>{row.Catalog_Item?.sku || ""}</div>
                    </div>

                    {this.state.hideSkuCol ? (
                        <OwBarcode format={"CODE128"} value={row.Catalog_Item?.sku || ""} height={40} displayValue={false} />
                    ) : null}
                </div>
            );
        } else {
            return null;
        }
    };

    renderUpcFn = (row: IOrder_ItemUI) => {
        if (row.Catalog_Item?.upc) {
            return <OwBarcode format={"UPC"} value={row.Catalog_Item.upc} height={25} displayValue={true} />;
        } else {
            return null;
        }
    };

    renderUomFn = (row: IOrder_ItemUI) => {
        if (row.Catalog_Item?.Unit_Of_Measurement?.abbreviation) {
            return row.Catalog_Item?.Unit_Of_Measurement?.abbreviation;
        } else {
            return null;
        }
    };

    pickQtyRenderFn = (row: IOrder_ItemUI) => {
        return this.state.qtyAssigned[row.guid].qty_picked;
    };

    orderQtyRenderFn = (row: IOrder_ItemUI) => {
        return row.qty;
    };

    selectLot = (lot: ILot, row: IOrder_ItemUI) => {
        // let orderItems = this.state.orderItems;
        //
        // for (let orderItem of orderItems) {
        //     if (orderItem.guid === row.guid) {
        //
        //         if (!orderItem.Lots) {
        //             orderItem.Lots = []
        //         }
        //
        //         if (orderItem.Lots.length) {
        //
        //         } else {
        //             orderItem.Lots.push(lot);
        //         }
        //         // orderItem.Lot = lot;
        //         // orderItem.Packing_List_Order_Item_Map.
        //     }
        // }
        //
        // this.setState({orderItems});
        const selectedLots = this.state.selectedLots;

        selectedLots[row.guid] = lot;

        this.setState({
            selectedLots,
        });
    };

    getLots = (name: string, row: IOrder_ItemUI) => {
        const payload: IGetLotsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogItemGuid: row.Catalog_Item!.guid,
            queryString: `?name=${name}`,
            limit: 8,
            rowGuid: row.guid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemGetLots, payload);
    };

    onGetLots = (data: IOnGetLotsDTO) => {
        const foundLots = this.state.foundLots;

        if (data.rowGuid) {
            foundLots[data.rowGuid] = data.lots;
        }

        this.setState({
            foundLots,
        });
    };

    createNewLot = (row: IOrder_ItemUI) => {
        const component = (
            <CreateLotSidebar
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                socket={this.props.socket}
                cancel={(refresh?: boolean, data?: IOnProcessLotDTO) => {
                    this.cancelSidebar(row, data!);
                }}
                catalogItemModel={row.Catalog_Item!}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);

        this.setState({
            clearTypeahead: true,
        });
    };

    cancelSidebar = (row: IOrder_ItemUI, data: IOnProcessLotDTO) => {
        console.log("Add Data: ", data);
        console.log("For Row: ", row);

        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    clearTypeahead = (row: IOrder_ItemUI) => {
        const selectedLots = this.state.selectedLots;

        selectedLots[row.guid] = null;

        this.setState({
            clearTypeahead: false,
            selectedLots,
        });
    };

    renderLotItems = (lot: ILotUI) => {
        return (
            <div className={"text-center"}>
                <div>{lot.name}</div>
                {lot.exp_date ? (
                    <div className={"text-small d-flex"}>
                        <OwLabel title={"exp"} postText={":"} className={"me-1"} />
                        {UserService.parseDate(lot.exp_date)}
                    </div>
                ) : null}
            </div>
        );
    };

    addLot = (row: IOrder_ItemUI) => {
        const lot = this.state.selectedLots[row.guid];

        if (!lot) {
            return null;
        }

        lot.qty = 0;

        const orderItems = this.state.orderItems;

        const orderItemLotMap = this.state.packingList.Order_Item_Lot_Maps;

        for (const orderItem of orderItems) {
            if (orderItem.guid === row.guid) {
                if (!orderItem.Lots) {
                    orderItem.Lots = [];
                }

                const newLotMap: INewOrder_Item_Lot_Map = {
                    lot_id: lot.id,
                    order_item_id: orderItem.id,
                    order_id: orderItem.order_id!,
                    catalog_item_id: orderItem.catalog_item_id,
                    packing_list_id: this.state.packingList.id,
                    qty: 0,
                };

                // @ts-expect-error
                orderItemLotMap.push(newLotMap);

                if (orderItem.Lots.length) {
                    let lotExists = false;

                    for (const existingLot of orderItem.Lots) {
                        if (lot.guid === existingLot.guid) {
                            lotExists = true;
                        }
                    }

                    if (!lotExists) {
                        orderItem.Lots.push(lot);
                    }
                } else {
                    orderItem.Lots.push(lot);
                }
                // orderItem.Lot = lot;
                // orderItem.Packing_List_Order_Item_Map.
            }
        }

        const packingList = this.state.packingList;

        packingList.Order_Item_Lot_Maps = orderItemLotMap;

        this.setState({ orderItems, packingList });
    };

    deleteLot = (lot: ILotUI, parentRowIndex: number) => {
        const orderItems = this.state.orderItems;

        const orderItem = orderItems[parentRowIndex];

        if (orderItem && orderItem.Lots) {
            for (const itemLot of orderItem.Lots) {
                if (itemLot.guid === lot.guid) {
                    itemLot.deleteFlag = true;
                }
            }
        }

        this.setState({
            orderItems,
            hasUnsavedChanges: true,
        });
    };

    handleQtyChange = (e: ChangeEvent<any>, lot: ILotUI, parentRowIndex: number) => {
        const orderItems = this.state.orderItems;

        const orderItem = orderItems[parentRowIndex];

        if (orderItem && orderItem.Lots) {
            for (const itemLot of orderItem.Lots) {
                if (itemLot.guid === lot.guid) {
                    itemLot.qty = Number(e.target.value || 0);
                }
            }
        }

        const packingList = this.state.packingList;
        const orderItemLotMaps = packingList.Order_Item_Lot_Maps;

        if (packingList) {
            if (orderItemLotMaps) {
                for (const orderItemLotMap of orderItemLotMaps) {
                    if (orderItemLotMap.lot_id === lot.id && orderItemLotMap.order_item_id === orderItem.id) {
                        console.log("handleQtyChange: ", orderItemLotMap, e.target.value);
                        if (!_.isNil(e.target.value)) {
                            orderItemLotMap.qty = Number(e.target.value || 0);
                        }
                    }
                }
            }
        }

        packingList.Order_Item_Lot_Maps = orderItemLotMaps;

        this.setState({
            orderItems,
            packingList,
            hasUnsavedChanges: true,
        });
    };

    renderLotQtyInputFn = (lot: ILotUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        if (_.isNil(parentRowIndex)) {
            return null;
        }

        const parentOrderItem = this.state.orderItems[parentRowIndex];

        let orderItemLotQty = 0;

        if (this.state.packingList) {
            if (this.state.packingList.Order_Item_Lot_Maps) {
                for (const orderItemLotMap of this.state.packingList.Order_Item_Lot_Maps) {
                    if (orderItemLotMap.lot_id === lot.id && parentOrderItem.id === orderItemLotMap.order_item_id) {
                        if (!_.isNil(orderItemLotMap.qty)) {
                            orderItemLotQty = orderItemLotMap.qty;
                        } else {
                            orderItemLotQty = 0;
                        }
                    }
                }
            }
        }

        if (this.state.packingList.is_locked) {
            return <div>{orderItemLotQty}</div>;
        } else {
            return (
                <div>
                    <OwInputWrapper
                        name={"qty"}
                        value={orderItemLotQty}
                        fn={(e: ChangeEvent<any>) => {
                            this.handleQtyChange(e, lot, parentRowIndex);
                        }}
                        type={"number"}
                        onWheelFn={UIService.stopScrollWheel}
                    />
                </div>
            );
        }
    };

    renderLotActionColFn = (lot: ILotUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        // console.log('renderLotActionColFn: ', lot, rowIndex, isDetailViewTable, parentRowIndex);
        if (_.isNil(parentRowIndex) || this.state.packingList.is_locked) {
            return null;
        }

        return (
            <div className={"d-print-none"}>
                <i
                    className={"fad fa-trash-alt text-danger pointer"}
                    title={"Delete Lot?"}
                    onClick={() => {
                        this.deleteLot(lot, parentRowIndex);
                    }}
                />
            </div>
        );
    };

    getLotTableCols = (): IOwTableCols[] => {
        const cols: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                renderFn: this.renderLotActionColFn,
                renderFnEmitsRow: true,
                isActionsCol: true,
                className: "d-print-none",
            },
            {
                title: "qty",
                valueProp: "qty",
                renderFn: this.renderLotQtyInputFn,
                renderFnEmitsRow: true,
                className: "w-7r",
            },
            {
                title: "lot",
                valueProp: "name",
            },
        ];

        if (this.props.supplierModel.has_exp_date) {
            cols.push({
                title: "exp_date",
                valueProp: "exp_date",
                renderFn: (dateStr: string) => {
                    return UserService.parseDate(dateStr);
                },
            });
        }

        return cols;
    };

    lotsDetailView = (row: IOrder_ItemUI, parentRowIndex: number) => {
        const selectedItem = null;

        return (
            <div>
                <div className={"d-flex"}>
                    <OwTitle title={"lots"} tag={"h5"} isUnderline={true} />
                </div>
                {this.state.packingList.is_locked ? null : (
                    <div className={"row d-flex d-print-none"}>
                        <div className={"col-12 col-sm-6 col-md-4 col-lg-3 pe-2"}>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={(str: string) => {
                                    this.getLots(str, row);
                                }}
                                typeaheadItems={this.state.foundLots[row.guid]}
                                title={"name"}
                                itemsRenderFn={this.renderLotItems}
                                selectedItemFn={(lot: ILot) => {
                                    this.selectLot(lot, row);
                                }}
                                selectedItem={this.state.selectedLots[row.guid]}
                                selectedItemTitleProp={"name"}
                                showCreateNew={true}
                                createNewFn={() => {
                                    this.createNewLot(row);
                                }}
                                clearTypeahead={this.state.clearTypeahead}
                                clearTypeaheadCallback={() => {
                                    this.clearTypeahead(row);
                                }}
                            />
                        </div>

                        <div className={"col ps-0"}>
                            <OwButton
                                title={"add"}
                                leftIconClass={"fas fa-plus"}
                                fn={() => {
                                    this.addLot(row);
                                }}
                                disabled={!this.state.selectedLots[row.guid]}
                            />
                        </div>
                    </div>
                )}
                <div className={"mt-2"}>
                    <OwTable
                        columns={this.getLotTableCols()}
                        dataSet={(row.Lots || []).filter((lot) => {
                            return !lot.deleteFlag;
                        })}
                        dataFetch={false}
                        initialData={false}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        isDetailViewTable={true}
                        parentRowIndex={parentRowIndex}
                    />
                </div>
            </div>
        );
    };

    hasLotsChange = (e: ChangeEvent<any>, row: IOrder_ItemUI) => {
        const orderItems = this.state.orderItems;

        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        for (const orderItem of orderItems) {
            if (orderItem.guid === row.guid) {
                orderItem.Packing_List_Order_Item_Map!.has_lots = value;
                orderItem.use_lots = value;
            }
        }

        this.setState({
            orderItems,
            hasUnsavedChanges: true,
        });
    };

    detailViewRowOverride = (row: IOrder_ItemUI) => {
        return !!row.Packing_List_Order_Item_Map?.has_lots;
    };

    hasLotsRenderFn = (row: IOrder_ItemUI) => {
        if (this.state.packingList.is_locked) {
            return null;
        } else {
            return (
                <OwCheckbox
                    name={"use_lots"}
                    fn={(e: ChangeEvent<any>) => {
                        this.hasLotsChange(e, row);
                    }}
                    checked={row.Packing_List_Order_Item_Map!.has_lots}
                    truthyVal={true}
                    falsyVal={false}
                    label={"use_lots"}
                />
            );
        }
    };

    lotRenderFn = (row: IOrder_ItemUI) => {
        const lots = row.Lots || [];
        let selectedLot: any | null = null;

        if (lots.length) {
            selectedLot = lots[0];
        }

        return (
            <div>
                <Typeahead
                    isSelectableFn={() => {
                        return true;
                    }}
                    typeaheadApiFn={(str: string) => {
                        this.getLots(str, row);
                    }}
                    typeaheadItems={this.state.foundLots[row.guid]}
                    title={"name"}
                    itemsRenderFn={this.renderLotItems}
                    selectedItemFn={(lot: ILot) => {
                        this.selectLot(lot, row);
                    }}
                    selectedItem={selectedLot}
                    selectedItemTitleProp={"name"}
                    showCreateNew={true}
                    createNewFn={() => {
                        this.createNewLot(row);
                    }}
                    clearTypeahead={this.state.clearTypeahead}
                    clearTypeaheadCallback={() => {
                        this.clearTypeahead(row);
                    }}
                />
            </div>
        );
    };

    expDateRenderFn = (row: IOrder_ItemUI) => {
        const lots = row.Lots || [];
        let selectedLot: any | null = null;

        if (lots.length) {
            selectedLot = lots[0];

            return <div>{UserService.parseDate(selectedLot.exp_date)}</div>;
        } else {
            return <div>--</div>;
        }
    };

    cartonRenderFn = (row: IOrder_ItemUI) => {
        if (this.state.packingList.is_locked) {
            return row.Packing_List_Order_Item_Map?.cartons;
        } else {
            return (
                <div>
                    <OwInputWrapper
                        name={"cartons"}
                        fn={(e: any) => {
                            this.handleCartonChange(e, row);
                        }}
                        value={row.Packing_List_Order_Item_Map?.cartons}
                        onWheelFn={UIService.stopScrollWheel}
                    />
                </div>
            );
        }
    };

    showChevronFn = (row: IOrder_ItemUI): boolean => {
        return !!row.Catalog_Item?.has_alternate_sourcing;
    };

    handleQtyAssignedChange = (e: any, row: IOrder_ItemUI) => {
        const value = e.target.value;
        const name = e.target.name;

        const qtyAssigned = this.state.qtyAssigned;

        qtyAssigned[row.guid].value = Number(value);

        this.setState({
            qtyAssigned,
            hasUnsavedChanges: true,
        });
    };

    handleCartonChange = (e: any, row: IOrder_ItemUI) => {
        const value = e.target.value;
        const name = e.target.name;

        const orderItems = this.state.orderItems;

        for (const orderItem of orderItems) {
            if (orderItem.guid === row.guid) {
                if (orderItem.Packing_List_Order_Item_Map) {
                    orderItem.Packing_List_Order_Item_Map.cartons = value;
                }
            }
        }

        this.setState({
            orderItems,
            hasUnsavedChanges: true,
        });
    };

    handlePickedChange = (e: any, row: ICatalog_Item, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
        if (!_.isNil(parentRowIndex)) {
            const qtyAssigned = this.state.qtyAssigned;

            const parentOrderItem = this.state.orderItems[parentRowIndex];

            if (!qtyAssigned[parentOrderItem.guid].sources[row.guid]) {
                qtyAssigned[parentOrderItem.guid].sources[row.guid] = {
                    qty_picked: 0,
                    value: 0,
                    parent_catalog_item_id: parentOrderItem.Catalog_Item!.id,
                    order_id: parentOrderItem!.order_id!,
                };
            }

            qtyAssigned[parentOrderItem.guid].sources[row.guid].value = Number(e.target.value);

            const keys = Object.keys(qtyAssigned[parentOrderItem.guid].sources);

            let qtyAssignedTotal = 0;

            for (const key of keys) {
                qtyAssignedTotal += Number(qtyAssigned[parentOrderItem.guid].sources[key].value);
            }

            qtyAssigned[parentOrderItem.guid].value = qtyAssignedTotal;

            this.setState({
                qtyAssigned,
                hasUnsavedChanges: true,
            });
        }
    };

    qtyPickedRenderFn = (row: ICatalog_Item, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
        // console.log("qtyPickedRenderedFn", row, rowIndex, isDetailView, parentRowIndex);
        if (!_.isNil(parentRowIndex)) {
            const parentOrderItem = this.state.orderItems[parentRowIndex];

            let value = 0;

            if (this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid]) {
                if (this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].qty_picked) {
                    if (this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].value === 0) {
                        value = this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].qty_picked;
                    } else {
                        value = this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].value;
                    }
                } else {
                    if (this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].value) {
                        value = this.state.qtyAssigned[parentOrderItem.guid].sources[row.guid].value;
                    }
                }
            }

            if (this.state.packingList.is_locked) {
                return <div className={"text-center"}>{value}</div>;
            } else {
                // console.log("qtyPickedRenderFn", value, this.state.qtyAssigned[parentOrderItem.guid].sources);

                return (
                    <OwInputWrapper
                        key={row.guid}
                        type={"number"}
                        value={value}
                        fn={(e: any) => {
                            this.handlePickedChange(e, row, rowIndex, isDetailView, parentRowIndex);
                        }}
                        name={"qty_assigned"}
                        className={"text-end"}
                        onWheelFn={UIService.stopScrollWheel}
                    />
                );
            }
        }
    };

    qtyShippedRenderFn = (qtyShipped: string) => {
        return qtyShipped ? qtyShipped : 0;
    };

    shipQtyRenderFn = (row: IOrder_ItemUI) => {
        let value = 0;

        if (this.state.qtyAssigned[row.guid]) {
            if (this.state.qtyAssigned[row.guid].qty_picked >= 0) {
                if (this.state.qtyAssigned[row.guid].value >= 0) {
                    value = this.state.qtyAssigned[row.guid].value;
                } else {
                    value = this.state.qtyAssigned[row.guid].qty_picked;
                }
            } else {
                value = this.state.qtyAssigned[row.guid].value;
            }
        }

        if (this.state.packingList.is_locked) {
            return <div>{value}</div>;
        } else {
            return (
                <OwInputWrapper
                    type={"number"}
                    className={"text-end"}
                    name={"qty_assigned"}
                    value={value}
                    fn={(e: any) => {
                        this.handleQtyAssignedChange(e, row);
                    }}
                    disabled={row.Catalog_Item?.has_alternate_sourcing || row.use_lots}
                    onWheelFn={UIService.stopScrollWheel}
                />
            );
        }
    };

    orderRenderFn = (row: IOrder_ItemUI) => {
        if (this.state.packingList.Orders) {
            for (const order of this.state.packingList.Orders) {
                if (row.order_id === order.id) {
                    return order.name;
                }
            }
        } else {
            return "";
        }
    };

    getPackingList = () => {
        const payload: IGetPackingListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            packingListGuid: this.state.packingListGuid,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetPackingList, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onUpdatePackingList = (data: IOnUpdatePackingListDTO) => {
        this.setState(
            {
                isSaveActive: false,
                hasUnsavedChanges: false,
            },
            () => {
                this.getPackingList();
            }
        );
    };

    onUpdatePackingListLock = (data: IOnUpdatePackingListLockDTO) => {
        this.setState(
            {
                isFinalizeActive: false,
            },
            () => {
                this.getPackingList();
            }
        );
    };

    onGetPackingList = (data: IOnGetPackingListDTO) => {
        const qtyAssigned = this.state.qtyAssigned;

        const orderItemsFiltered = (data.packingList.Order_Items || []).filter((orderItem) => {
            if (data.packingList && data.packingList.Packing_List_Catalog_Item_Maps) {
                const catItemMaps = data.packingList.Packing_List_Catalog_Item_Maps;

                let found = false;

                for (const catItem of catItemMaps) {
                    if (catItem.order_item_id === orderItem.id) {
                        found = true;
                    }
                }

                const Product_Sources = orderItem.Catalog_Item?.Product_Sources;

                if (Product_Sources) {
                    const pickedProductSources: ICatalog_Item[] = [];

                    for (const productSource of Product_Sources) {
                        let productSourceFound = false;

                        for (const catItem of catItemMaps) {
                            if (catItem.catalog_item_id === productSource.id) {
                                productSourceFound = true;
                            }
                        }

                        if (productSourceFound) {
                            pickedProductSources.push(productSource);
                        }
                    }

                    orderItem.Catalog_Item!.Product_Sources = pickedProductSources;
                }

                // console.log("Found Item: ", found);

                return found;
            }
        });

        const selectedLots = this.state.selectedLots;

        if (data.packingList.Order_Items) {
            for (const orderItem of data.packingList.Order_Items) {
                if (!selectedLots[orderItem.guid]) {
                    selectedLots[orderItem.guid] = null;
                }

                const packingListOrderItemMap = orderItem!.Packing_List_Order_Item_Map;

                const sources: any = {};

                if (orderItem.Catalog_Item?.has_alternate_sourcing) {
                    const catItemMapId = orderItem?.Packing_List_Order_Item_Map?.packing_list_cat_item_map_id;

                    if (data.packingList.Packing_List_Catalog_Item_Maps) {
                        for (const itemMap of data.packingList.Packing_List_Catalog_Item_Maps) {
                            if (itemMap.id === catItemMapId) {
                                // sources[itemMap.Catalog_Item!.guid] = {
                                //     value: itemMap.qty_packed,
                                //     parent_catalog_item_id: itemMap.parent_catalog_item_id,
                                //     order_id: itemMap.order_id,
                                //     order_item_id: itemMap.order_item_id
                                // }
                            }

                            if (itemMap.order_item_id === orderItem.id && itemMap.parent_catalog_item_id) {
                                let qty_picked = 0;

                                if (data.packingList.Pick_List && data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                                    for (const pickCatItem of data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                                        if (
                                            pickCatItem.catalog_item_id === itemMap.catalog_item_id &&
                                            pickCatItem.parent_catalog_item_id === itemMap.parent_catalog_item_id
                                        ) {
                                            qty_picked = pickCatItem.qty_picked;
                                        }
                                    }
                                }

                                sources[itemMap.Catalog_Item!.guid] = {
                                    qty_picked,
                                    value: itemMap.qty_packed || qty_picked,
                                    parent_catalog_item_id: itemMap.parent_catalog_item_id,
                                    order_id: itemMap.order_id,
                                    order_item_id: itemMap.order_item_id,
                                };
                            }
                        }
                    }

                    // if (data.packingList.Catalog_Items) {
                    //     for (const catalogItem of data.packingList.Catalog_Items) {
                    //         if (catalogItem.Packing_List_Catalog_Item_Map?.id === catItemMapId &&
                    //             catalogItem.Packing_List_Catalog_Item_Map.parent_catalog_item_id) {
                    //             sources[catalogItem.guid] = {
                    //                 value: catalogItem.Packing_List_Catalog_Item_Map.qty_packed,
                    //                 parent_catalog_item_id: catalogItem.Packing_List_Catalog_Item_Map.parent_catalog_item_id,
                    //                 order_item_id: orderItem.id
                    //             };
                    //         }
                    //     }
                    // }
                }

                let qty_picked = 0;

                if (data.packingList.Pick_List && data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                    for (const catItemMap of data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                        if (catItemMap.catalog_item_id === orderItem.catalog_item_id) {
                            qty_picked = catItemMap.qty_picked;
                        }
                    }
                }

                qtyAssigned[orderItem.guid] = {
                    qty_picked,
                    value: packingListOrderItemMap?.qty_assigned || 0,
                    sources,
                };
            }
        }

        // console.log("orderItemsFiltered", orderItemsFiltered);

        const orderItems = orderItemsFiltered;

        for (const orderItem of orderItems) {
            if (orderItem.use_lots) {
                qtyAssigned[orderItem.guid].value = 0;
            }
        }

        // This function needs to be unit tested. It feels 'dangerous'
        if (data.packingList.Order_Item_Lot_Maps && data.packingList.Order_Item_Lot_Maps.length) {
            for (const itemLotMap of data.packingList.Order_Item_Lot_Maps) {
                for (const orderItem of orderItems) {
                    if (orderItem.id === itemLotMap.order_item_id) {
                        if (!orderItem.Lots) {
                            orderItem.Lots = [];
                        }

                        if (itemLotMap.Lot) {
                            orderItem.Lots.push(itemLotMap.Lot);
                            qtyAssigned[orderItem.guid].value += itemLotMap.qty || 0;
                        }
                    }
                }
            }
        }

        const orderItemsSorted = _.sortBy(
            orderItems,
            (item) => {
                return item.Catalog_Item?.sku;
            },
            ["asc"]
        );

        const foundLots = this.state.foundLots;

        for (const orderItem of orderItems) {
            if (!foundLots[orderItem.guid]) {
                foundLots[orderItem.guid] = [];
            }
        }

        // console.log("onGetPackingList", qtyAssigned);

        document.title = `Orderwerks >> Packing List >> ${data.packingList.name}`;

        let hasUnsavedChanges = this.state.hasUnsavedChanges;

        if (this.state.isInitialData && !data.packingList.is_locked) {
            hasUnsavedChanges = true;
        }

        this.setState({
            hasUnsavedChanges,
            packingList: data.packingList,
            catalogItems: data.packingList.Catalog_Items || [],
            orderItems: orderItemsSorted,
            isDataFetching: false,
            isInitialData: false,
            qtyAssigned,
            foundLots,
            selectedLots,
            showOrder: !(data.packingList.Orders?.length === 1),
            totalOrders: data.packingList.Orders?.length || 0,
        });
    };

    savePackingList = () => {
        const orderItemKeys = Object.keys(this.state.qtyAssigned);

        const rows: IUpdatePackingListRow[] = [];
        const sourceRows: IUpdatePackingListSourceRow[] = [];

        for (const orderItemKey of orderItemKeys) {
            const orderItemRow = this.state.qtyAssigned[orderItemKey];

            const row: IUpdatePackingListRow = {
                orderItemGuid: orderItemKey,
                qtyAssigned: Number(orderItemRow.value),
            };

            const sourcesKeys = Object.keys(orderItemRow.sources);

            let rowQty = 0;

            if (sourcesKeys.length) {
                for (const sourceKey of sourcesKeys) {
                    const sourceDetail = orderItemRow.sources[sourceKey];

                    const sourceRow: IUpdatePackingListSourceRow = {
                        catalogItemGuid: sourceKey,
                        qtyPacked: Number(sourceDetail.value),
                        parentCatalogItemId: sourceDetail.parent_catalog_item_id,
                        orderId: sourceDetail.order_id,
                    };

                    sourceRows.push(sourceRow);

                    rowQty += sourceRow.qtyPacked;
                }

                row.qtyAssigned = rowQty;
            }

            rows.push(row);
        }

        if (this.state.orderItems) {
            for (const orderItem of this.state.orderItems) {
                for (const row of rows) {
                    if (row.orderItemGuid === orderItem.guid) {
                        if (orderItem.Packing_List_Order_Item_Map) {
                            if (orderItem.Packing_List_Order_Item_Map.cartons) {
                                row.cartons = orderItem.Packing_List_Order_Item_Map.cartons;
                            }
                        }

                        if (orderItem.Lots) {
                            const lotsProcessed = orderItem.Lots.filter((lot) => {
                                return !_.isNil(lot.qty);
                            });

                            row.lots = lotsProcessed.map((lot: ILotUI) => {
                                // TODO delete flag?

                                return {
                                    qty: lot.qty,
                                    lot_id: lot.id,
                                    deleteFlag: lot.deleteFlag,
                                };
                            });
                        }

                        if (orderItem.use_lots) {
                            row.use_lots = orderItem.use_lots;
                        }
                    }
                }
            }
        }

        const payload: IUpdatePackingListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            packingListGuid: this.state.packingList.guid,
            rows,
            sourceRows,
        };

        this.props.socket.emit(EndpointsEnum.OrderUpdatePackingList, payload);

        this.setState({
            isSaveActive: true,
        });
    };

    updatePackingListLock = (isLocked = true) => {
        const payload: IUpdatePackingListLockDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            packingListGuid: this.state.packingList.guid,
            isLocked,
        };

        this.props.socket.emit(EndpointsEnum.OrderUpdatePackingListLock, payload);

        this.setState({
            isFinalizeActive: true,
        });
    };

    createShipment = () => {
        const payload: ICreateShipmentFromPackingListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            packingListGuid: this.state.packingList.guid,
            height: this.state.height,
            length: this.state.length,
            width: this.state.width,
            shipment_date: this.state.shipment_date,
            shipment_status_id: this.state.shipment_status_id,
            shipping_carrier_id: this.state.shipping_carrier_id,
            note: this.state.note,
            is_partial: false,
            tracking: this.state.tracking,
        };
    };

    cancel = () => {
        this.props.toggleSidebar(false);
        this.getPackingList();
    };

    shipmentProcessed = () => {};

    onShipmentUpdate = () => {};

    showShipmentSidebar = () => {
        const component = (
            <ShipmentPackageSidebar
                shipmentGroup={{} as IShipment_Group}
                packingList={this.state.packingList}
                cancel={this.cancel}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                processedFn={this.shipmentProcessed}
                onUpdateFn={this.onShipmentUpdate}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.props.setSidebarComponent(component);

        this.props.toggleSidebar(true);
    };

    getDate = (orderModel: IOrder, property: "confirmed_date" | "estimated_shipping_at" | "created_at" | "submit_date"): string => {
        if (orderModel) {
            if (orderModel[property]) {
                return UserService.parseDate(orderModel[property]);
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    getViewOptions = () => {
        const viewOptions: IViewOptions[] = [
            {
                title: "hide_business_name",
                prop: "hideBusinessName",
                type: ControlTypeEnum.checkbox,
                value: this.state.hideBusinessName,
            },
            {
                title: "inline_logo_name",
                prop: "inlineLogoName",
                type: ControlTypeEnum.checkbox,
                value: this.state.inlineLogoName,
            },
            {
                title: "show_item_photo",
                prop: "showItemPhoto",
                type: ControlTypeEnum.checkbox,
                value: this.state.showItemPhoto,
            },
            {
                title: "show_sku",
                prop: "showSku",
                type: ControlTypeEnum.checkbox,
                value: this.state.showSku,
            },
            {
                title: "sku_as_barcode",
                prop: "hideSkuCol",
                type: ControlTypeEnum.checkbox,
                value: this.state.hideSkuCol,
            },
            {
                title: "show_order_description",
                prop: "showOrderDescription",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderDescription,
            },
            {
                title: "show_upc",
                prop: "showUpc",
                type: ControlTypeEnum.checkbox,
                value: this.state.showUpc,
            },
            {
                title: "show_phone",
                prop: "showPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showPhone,
            },
            {
                title: "show_email",
                prop: "showEmail",
                type: ControlTypeEnum.checkbox,
                value: this.state.showEmail,
            },
            {
                title: "show_order_qty",
                prop: "showOrderQty",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderQty,
            },
            {
                title: "show_ship_qty",
                prop: "showShipQty",
                type: ControlTypeEnum.checkbox,
                value: this.state.showShipQty,
            },
            {
                title: "show_pick_qty",
                prop: "showPickQty",
                type: ControlTypeEnum.checkbox,
                value: this.state.showPickQty,
            },
            {
                title: "show_dropshipment",
                prop: "showDropshipment",
                type: ControlTypeEnum.checkbox,
                value: this.state.showDropshipment,
            },
            {
                title: "show_bill_to",
                prop: "showBillTo",
                type: ControlTypeEnum.checkbox,
                value: this.state.showBillTo,
            },
            {
                title: "show_bill_to_phone",
                prop: "showBillToPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showBillToPhone,
            },
            {
                title: "show_ship_to_phone",
                prop: "showShipToPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showShipToPhone,
            },
            {
                title: "show_order_user",
                prop: "showOrderUser",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderUser,
            },
            // {
            //     title: "show_item_location",
            //     prop: "showItemLocation",
            //     type: ControlTypeEnum.checkbox,
            //     value: this.state.showItemLocation,
            // },
            {
                title: "show_uom",
                prop: "showUom",
                type: ControlTypeEnum.checkbox,
                value: this.state.showUom,
            },
        ];

        return viewOptions;
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    rowHasDetailView = (row: IOrder_ItemUI): boolean => {
        if (row.Catalog_Item?.Product_Sources) {
            return true;
        }

        if (row.use_lots) {
            return true;
        }

        return false;
    };

    saveViewOptionsFn = () => {};

    selectPageSize = (pageSize: IOption) => {
        this.setState({
            pageSize: pageSize.value as "STANDARD" | "MINIMAL",
        });
    };

    getOrders = (): { orders: IOrder[]; firstOrder: IOrder } => {
        const orders: IOrder[] = this.state.packingList && this.state.packingList.Orders ? this.state.packingList.Orders : [{} as IOrder];
        const firstOrder = orders[0];

        return { orders, firstOrder };
    };

    getCompiledData = (): {
        orderNumsArr: string[];
        poNumsArr: string[];
        notes: string;
        shipping_instructions: string;
        orderDescription: string;
    } => {
        const { orders, firstOrder } = this.getOrders();

        const orderNumsArr: string[] = [];
        const poNumsArr: string[] = [];
        let notes = "";
        let shipping_instructions = "";
        let orderDescription = "";

        _.each(orders, (order) => {
            orderNumsArr.push(order.name!);

            if (order.po_no) {
                poNumsArr.push(order.po_no);
            }

            if (!_.isNil(order.note)) {
                notes += order.note + "\n";
            }

            if (!_.isNil(order.shipping_instructions)) {
                if (orders.length > 1) {
                    shipping_instructions += `${order.name!}: ${order.shipping_instructions}`;
                } else {
                    shipping_instructions += `${order.shipping_instructions}`;
                }
            }

            if (!_.isNil(order.description)) {
                if (orders.length > 1) {
                    orderDescription += `${order.name!}: ${order.description}`;
                } else {
                    orderDescription += `${order.description}`;
                }
            }
        });

        return { orderNumsArr, poNumsArr, notes, shipping_instructions, orderDescription };
    };

    getOrderDate = () => {
        const { orders, firstOrder } = this.getOrders();

        let orderDate = "";

        if (orders.length > 2) {
            orderDate = "Mixed";
        } else {
            if (firstOrder.confirmed_date) {
                orderDate = this.getDate(firstOrder, "confirmed_date");
            } else if (firstOrder.submit_date) {
                orderDate = this.getDate(firstOrder, "submit_date");
            } else {
                orderDate = this.getDate(firstOrder, "created_at");
            }
        }

        return orderDate;
    };

    render() {
        const { orders, firstOrder } = this.getOrders();

        if (!firstOrder) {
            return <div className={"mt-5"}>Error. No Order - Did you delete it?</div>;
        }

        const supplierShipTo: IAddress = _.get(this.state.packingList, "Supplier.Ship_To", {} as IAddress);
        const shipmentGroupShipTo: IAddress = _.get(firstOrder, "Ship_To", this.state.packingList.Vendor?.Ship_To || ({} as IAddress));
        const shipmentGroupBillTo: IAddress = _.get(firstOrder, "Bill_To", this.state.packingList.Vendor?.Bill_To || ({} as IAddress));

        const vendorModel: IVendorModel = _.get(this.state.packingList, "Vendor", {} as IVendorModel);
        const OrderItems = _.sortBy(this.state.packingList.Order_Items, ["item_no", "asc"]);

        const orderDate = this.getOrderDate();

        const estShipDate = orders.length > 2 ? "Mixed" : this.getDate(firstOrder, "estimated_shipping_at");
        const cancelDate = orders.length > 2 ? "Mixed" : moment(firstOrder.cancel_date).format("MM/DD/YYYY");
        const shippingDate = orders.length > 2 ? "Mixed" : moment(firstOrder.ship_date).format("MM/DD/YYYY");
        const doNotShipBeforeDate = orders.length > 2 ? "Mixed" : moment(firstOrder.do_not_ship_before_date).format("MM/DD/YYYY");

        const { shipping_instructions, notes, poNumsArr, orderNumsArr, orderDescription } = this.getCompiledData();

        const orderNums = orderNumsArr.join(", ");
        const poNums = poNumsArr.join(",");
        const totalQty = 0;

        // const orderItemRows = _.map(OrderItems, (orderItem: any, index: number) => {
        //     if (_.isNumber(orderItem.total_qty)) {
        //         totalQty += Number(orderItem.total_qty);
        //     }
        //
        //     return (
        //         <PackingListItemRow
        //             orderItem={orderItem}
        //             showItemPhoto={this.state.showItemPhoto}
        //             showOrderQty={this.state.showOrderQty}
        //             showShipQty={this.state.showShipQty}
        //             showDropshipment={this.state.showDropshipment}
        //             showUpc={this.state.showUpc}
        //             showSku={this.state.showSku}
        //             showLot={!!this.props.supplierModel.has_lots}
        //             hideSkuCol={this.state.hideSkuCol}
        //             order={orders[0]}
        //             supplierModel={this.props.supplierModel}
        //             showItemLocation={false}
        //             showUom={this.state.showUom}
        //         />
        //     );
        // });

        const viewOptions = this.getViewOptions();

        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        let isNotLocalDeliveryOrPickup = true;
        let isLocalDelivery = false;
        let isLocalPickup = false;

        if (this.state.packingList.Orders) {
            for (const order of this.state.packingList.Orders) {
                if (order.is_local_pickup || order.is_local_delivery) {
                    isNotLocalDeliveryOrPickup = false;
                }
            }

            if (this.state.packingList.Orders?.length === 1) {
                const order = this.state.packingList.Orders[0];

                if (order.is_local_delivery) {
                    isLocalDelivery = true;
                }

                if (order.is_local_pickup) {
                    isLocalPickup = true;
                }
            }
        }

        let tableTheme = "";

        if (!UIService.isMainViewLight()) {
            tableTheme = "table-dark";
        }

        let hasBillToName = true;
        let hasShipToName = true;

        if (!shipmentGroupBillTo?.name?.length || !shipmentGroupBillTo?.company_name?.length) {
            let billToNameSame = false;
            let billToCompanyNameSame = false;

            if (shipmentGroupBillTo?.name === vendorModel?.name) {
                billToNameSame = true;
            }

            if (shipmentGroupBillTo?.company_name === vendorModel?.name) {
                billToCompanyNameSame = true;
            }

            if (!billToNameSame && !billToCompanyNameSame) {
                hasBillToName = false;
            }
        }

        if (!shipmentGroupShipTo?.name?.length || !shipmentGroupShipTo?.company_name?.length) {
            let shipToNameSame = false;
            let shipToCompanyNameSame = false;

            if (shipmentGroupShipTo?.name === vendorModel?.name) {
                shipToNameSame = true;
            }

            if (shipmentGroupShipTo?.company_name === vendorModel?.name) {
                shipToCompanyNameSame = true;
            }

            if (!shipToNameSame && !shipToCompanyNameSame) {
                hasShipToName = false;
            }

            if (firstOrder.client_id) {
                hasShipToName = true;
            }
        }

        const getShowBillTo = () => {
            if (this.state.showBillTo) {
                if (this.state.pageSize === "STANDARD") {
                    return true;
                }
            }

            return false;
        };

        const showDetailRow = () => {
            return this.state.pageSize === "STANDARD";
        };

        return (
            <div className={"PackingListDetail mb-5 " + this.state.pageSize}>
                <OwViewOptionsPanel
                    viewOptions={viewOptions}
                    onChangeFn={this.handleChange}
                    showSaveBtn={true}
                    saveFn={this.saveViewOptionsFn}
                />

                <Breadcrumbs crumbs={this.state.crumbs} />

                <div className="row mt-2">
                    <div className={"col-12 text-end "}>
                        <div className={"d-print-none mb-2"}>
                            {!this.state.packingList.is_locked ? (
                                <div className={"mb-2"}>
                                    <OwButton
                                        className={"btn-primary d-print-none me-2"}
                                        title={"save"}
                                        fn={this.savePackingList}
                                        active={this.state.isSaveActive}
                                        disableOnActive={true}
                                    />
                                    <OwButton
                                        className={"btn-danger d-print-none"}
                                        leftIconClass={"fad fa-lock"}
                                        title={"finalize"}
                                        fn={() => {
                                            this.updatePackingListLock(true);
                                        }}
                                        active={this.state.isFinalizeActive}
                                        disableOnActive={true}
                                        disabled={this.state.hasUnsavedChanges}
                                    />
                                </div>
                            ) : null}

                            {this.state.packingList.is_locked && this.props.userModel?.userType?.id === UserTypesEnum.ADMIN ? (
                                <div className={"mb-2"}>
                                    <OwButton
                                        className={"btn-danger d-print-none"}
                                        leftIconClass={"fad fa-unlock"}
                                        title={"unlock"}
                                        fn={() => {
                                            this.updatePackingListLock(false);
                                        }}
                                        active={this.state.isFinalizeActive}
                                        disableOnActive={true}
                                        disabled={this.state.hasUnsavedChanges}
                                    />
                                </div>
                            ) : null}

                            <OwPrintButton/>

                            <div className={"d-flex justify-content-end my-2"}>
                                <OwSelectOption
                                    valueProp={"value"}
                                    titleProp={"label"}
                                    fn={this.selectPageSize}
                                    name={"pageSize"}
                                    options={this.packingListTemplates}
                                    emitObject={true}
                                    selectedOption={this.state}
                                    selectedOptionProp={"pageSize"}
                                />
                            </div>

                            {this.state.packingList &&
                            this.state.packingList.is_locked &&
                            !this.state.packingList.shipment_id &&
                            isNotLocalDeliveryOrPickup ? (
                                <OwButton leftIconClass={"fad fa-truck"} title={"create_shipment"} fn={this.showShipmentSidebar} />
                            ) : null}
                            {this.state.packingList && this.state.packingList.shipment_id ? (
                                <div>
                                    <Link to={`/shipments?packing_list=${this.state.packingList.name}`}>
                                        <OwLabel title={"view_shipment"} className={"pointer"} />
                                    </Link>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>

                {this.state.hasUnsavedChanges ? (
                    <div className={"text-end d-print-none"}>
                        <OwLabel title={"pending_changes_save_first"} className={"text-danger"} />
                    </div>
                ) : null}

                {/* Start Packing List Detail */}
                <div className={"top-row"}>
                    <div className={"d-flex justify-content-between"}>
                        <div className={" p-1 " + (this.state.inlineLogoName ? "d-flex" : "")}>
                            {this.props.supplierModel.Doc_Logo ? (
                                <DocLogo
                                    maxWidth={this.state.pageSize === "STANDARD" ? "20rem" : "10rem"}
                                    maxHeight={"8rem"}
                                    height={"auto"}
                                />
                            ) : (
                                <WhiteLabelLogo maxWidth={"20rem"} />
                            )}
                            {this.state.hideBusinessName ? null : (
                                <div className={this.state.inlineLogoName ? "ms-4" : ""}>
                                    <OwTitle
                                        disableTranslation={true}
                                        title={this.props.supplierModel.name}
                                        tag={"h5"}
                                        className={"mb-0"}
                                    />
                                    <div>{supplierShipTo.address_line_one}</div>
                                    <div>{supplierShipTo.address_line_two}</div>
                                    <div>
                                        {supplierShipTo.city}
                                        {supplierShipTo.state?.length ? "," : ""} {supplierShipTo.state} {supplierShipTo.postal_code}
                                    </div>
                                    <div className={"mt-2"}>
                                        {this.props.supplierModel.has_user_detail_on_packing_list ? (
                                            <div>
                                                <b>{firstOrder.User?.name}</b>
                                            </div>
                                        ) : null}
                                        <div
                                            className={
                                                this.state.showPhone && (supplierShipTo.phone?.length || firstOrder.User?.phone?.length)
                                                    ? ""
                                                    : "d-none"
                                            }>
                                            <b>
                                                <OwTranslate defaultMessage={"phone"} id={"phone"} />:
                                            </b>{" "}
                                            {this.props.supplierModel.has_user_detail_on_packing_list
                                                ? firstOrder.User?.phone || ""
                                                : supplierShipTo.phone}
                                        </div>
                                        <div className={this.state.showEmail && this.props.supplierModel.email ? "" : "d-none"}>
                                            <b>
                                                <OwTranslate defaultMessage={"email"} id={"email"} />:
                                            </b>{" "}
                                            {this.props.supplierModel.has_user_detail_on_packing_list
                                                ? firstOrder.User?.email || ""
                                                : this.props.supplierModel.email}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={"text-end align-items-end d-md-flex flex-column"}>
                            <OwTitle title={"packing_list"} tag={"h3"} isBold={true} />
                            <div>
                                <OwLabel title={"date"} postText={":"} /> {moment().format("MM/DD/YYYY")}
                            </div>
                            {firstOrder.allow_substitutions ? (
                                <p className={"mt-2"}>
                                    <OwLabel title={"allow_substitutions"} />
                                </p>
                            ) : null}
                            {firstOrder.allow_backorders ? (
                                <p className={"mt-2"}>
                                    <OwLabel title={"allow_backorders"} />
                                </p>
                            ) : null}
                            {firstOrder.is_local_pickup ? (
                                <p className={"mt-4"}>
                                    <OwTitle title={"local_pickup"} tag={"h4"} />
                                </p>
                            ) : null}
                            {firstOrder.is_local_delivery ? (
                                <p className={"mt-4"}>
                                    <OwTitle title={"local_delivery"} tag={"h4"} />
                                </p>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className={"row bill-to-ship-to-row"}>
                    {getShowBillTo() ? (
                        <div
                            className={
                                (this.state.pageSize === "STANDARD" ? "w-20r" : "") +
                                " col-auto " +
                                (this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? "d-none" : "")
                            }>
                            <div className={"black-box p-2 h-100"}>
                                <OwTitle leftIconName={"fal fa-building"} className={"underline"} title={"bill_to"} tag={"h5"} />
                                {!hasBillToName ? (
                                    <OwTitle title={firstOrder.Vendor?.name || ""} tag={"h5"} disableTranslation={true} />
                                ) : null}
                                <AddressDisplay
                                    address={shipmentGroupBillTo}
                                    showCompanyName={true}
                                    showName={true}
                                    showPhone={this.state.showBillToPhone}
                                    hideMobile={true}
                                    hideFax={true}
                                    hideEmail={true}
                                    nameTag={"h5"}
                                />
                            </div>
                        </div>
                    ) : null}

                    <div
                        className={
                            (this.state.pageSize === "STANDARD" ? "w-20r" : "") +
                            " col-auto " +
                            (this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? "" : "border-left-0")
                        }>
                        <div className={"black-box p-2 h-100 "}>
                            {firstOrder.is_local_pickup ? (
                                <OwTitle
                                    leftIconName={"fal fa-hand-holding-box"}
                                    title={"local_pickup"}
                                    tag={"h5"}
                                    className={"underline"}
                                />
                            ) : (
                                <OwTitle
                                    leftIconName={"fal fa-truck"}
                                    title={firstOrder.is_local_delivery ? "deliver_to" : "ship_to"}
                                    tag={"h5"}
                                    className={"underline"}
                                />
                            )}
                            {!hasShipToName ? <OwTitle title={firstOrder.Vendor?.name || ""} tag={"h5"} disableTranslation={true} /> : null}
                            <AddressDisplay
                                address={shipmentGroupShipTo}
                                showCompanyName={!firstOrder.client_id}
                                showName={true}
                                showPhone={this.state.showShipToPhone}
                                hideEmail={true}
                                hideFax={true}
                                hideMobile={true}
                                nameTag={"h5"}
                            />
                        </div>
                    </div>

                    {this.state.pageSize === "MINIMAL" ? (
                        <div className={"col-auto"}>
                            <table className={"table table-sm table-bordered w-100 " + tableTheme}>
                                <tbody>
                                <tr>
                                    <th>
                                        <strong>
                                            <OwLabel title={"order_date"} className={"mb-0"} />
                                        </strong>
                                    </th>
                                    <td>{orderDate}</td>
                                </tr>
                                {this.props.supplierModel?.shipping_lead_time ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"est_ship_date"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{estShipDate}</td>
                                    </tr>
                                ) : null}
                                {this.props.supplierModel?.has_order_cancel_date ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"cancel_date"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{firstOrder.cancel_date ? cancelDate : null}</td>
                                    </tr>
                                ) : null}
                                {!this.props.supplierModel?.has_est_ship_date ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"ship_date"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{firstOrder.ship_date ? shippingDate : null}</td>
                                    </tr>
                                ) : null}
                                {this.props.supplierModel?.has_do_not_ship_before_date ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"do_not_ship_before_date"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{firstOrder.do_not_ship_before_date ? doNotShipBeforeDate : null}</td>
                                    </tr>
                                ) : null}
                                {this.state.totalOrders === 1 ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"order_no"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{orderNums}</td>
                                    </tr>
                                ) : null}
                                {this.props.supplierModel?.has_terms_on_packing_list ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"terms"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>
                                            <OwLabel
                                                title={firstOrder.Vendor?.Payment_Type?.name.toLowerCase()}
                                                noBottomMargin={true}
                                            />
                                        </td>
                                    </tr>
                                ) : null}
                                <tr>
                                    <th>
                                        <strong>
                                            <OwLabel title={"po_no"} className={"mb-0"} />
                                        </strong>
                                    </th>
                                    <td>{poNums}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <strong>
                                            <OwLabel title={"notes"} className={"mb-0"} />
                                        </strong>
                                    </th>
                                    <td>{notes}</td>
                                </tr>
                                {firstOrder.shipping_instructions ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"shipping_instructions"} className={"mb-0"} />
                                            </strong>
                                        </th>
                                        <td>{firstOrder.shipping_instructions}</td>
                                    </tr>
                                ) : null}
                                {this.state.showOrderDescription ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"description"} />
                                            </strong>
                                        </th>
                                        <td>{orderDescription}</td>
                                    </tr>
                                ) : null}
                                {this.state.showOrderUser ? (
                                    <tr>
                                        <th>
                                            <strong>
                                                <OwLabel title={"user"} />
                                            </strong>
                                        </th>
                                        <td>{firstOrder.User?.name}</td>
                                    </tr>
                                ) : null}
                                </tbody>
                            </table>
                        </div>
                    ) : null}
                </div>

                {showDetailRow() ? (
                    <div className={"table-responsive"}>
                        <table className={"table table-bordered " + tableClass}>
                            <tbody>
                            <tr>
                                <th>
                                    <OwLabel title={"order_date"} className={"mb-0"} />
                                </th>
                                {this.props.supplierModel?.shipping_lead_time ? (
                                    <th>
                                        <OwLabel title={"est_ship_date"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                <th>
                                    <OwLabel title={"order_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"po_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"notes"} className={"mb-0"} />
                                </th>
                                {shipping_instructions.length ? (
                                    <th>
                                        <OwLabel title={"shipping_instructions"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                {this.state.showOrderDescription ? (
                                    <th>
                                        <OwLabel title={"description"} />
                                    </th>
                                ) : null}
                                {this.state.showOrderUser ? (
                                    <th>
                                        <OwLabel title={"user"} />
                                    </th>
                                ) : null}
                            </tr>
                            <tr>
                                <td>{orderDate}</td>
                                {this.props.supplierModel?.shipping_lead_time ? <td>{estShipDate}</td> : null}
                                <td>{orderNums}</td>
                                <td>{poNums}</td>
                                <td>{notes}</td>
                                {shipping_instructions.length ? <td>{shipping_instructions}</td> : null}
                                {this.state.showOrderDescription ? <td>{orderDescription}</td> : null}
                                {this.state.showOrderUser ? <td>{firstOrder.User?.name}</td> : null}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                ) : null}

                <div className={"items-row"}>
                    <OwTable
                        encloseRowsInTbody={true}
                        noDefaultWrappingClassName={true}
                        tableClassName={"table table-bordered " + tableTheme}
                        overrideTableClassName={true}
                        columns={this.state.columns}
                        dataSet={this.state.orderItems}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                        tableConfig={{ hasDetailView: true, detailViewFullWidth: false, tableHover: true }}
                        detailViewColumns={this.state.detailViewCols}
                        detailViewDataSetProp={"Catalog_Item"}
                        detailViewDataSetSubProp={"Product_Sources"}
                        detailViewInitialData={false}
                        detailViewDataFetch={false}
                        detailViewRowOverride={this.detailViewRowOverride}
                        detailViewComponent={this.lotsDetailView}
                        detailViewAlwaysVisible={!!this.props.supplierModel.has_lots}
                        rowDetailViewFn={this.rowHasDetailView}
                    />
                </div>
            </div>
        );
    }
}

export default PackingListDetail;
